import * as storage from 'reporting-data/lib/storage';
import { useHistory, useParams } from 'react-router-dom';
import { SMART_LIBRARY_PATHS } from '../types/navigation';
import { View } from 'foundations-components/components/View';
import { PREVIOUS_PATH_STORAGE_KEY } from '../constants/navigation';
import SingleReportViewerContainer from '../../containers/SingleReportViewerContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const AssetViewerContainer = () => {
  const {
    reportId
  } = useParams();
  const history = useHistory();
  const handleCloseViewer = () => {
    const previousPath = storage.get(PREVIOUS_PATH_STORAGE_KEY);
    if (previousPath) {
      history.push(previousPath);
    } else {
      history.push(SMART_LIBRARY_PATHS.USER_LIBRARY);
    }
  };
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-raised",
    children: /*#__PURE__*/_jsx(SingleReportViewerContainer, {
      reportId: reportId,
      handleCloseViewerOverride: handleCloseViewer
    })
  });
};